// 出入证
const niceProperty = [
  {
    path: '/privacyAgreementDetails',
    name: 'privacyAgreementDetails',
    meta: { title: '用户隐私协议' },
    component: () =>
        import(/* webpackChunkName: "agreement" */ '../views/NiceProperty/privacyAgreementDetails.vue'),
  },
  {
    path: '/serviceAgreementDetails',
    name: 'serviceAgreementDetails',
    meta: { title: '用户服务协议' },
    component: () =>
        import(/* webpackChunkName: "agreement" */ '../views/NiceProperty/serviceAgreementDetails.vue'),
  },
  
];
export default niceProperty;
  